var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', _vm._g({
    staticClass: "button-text",
    class: (_class = {}, _class[_vm.$style.button] = true, _class[_vm.$style.buttonBlue] = _vm.theme === 'blue', _class[_vm.$style.buttonLightBlue] = _vm.theme === 'lightBlue', _class[_vm.$style.buttonWhite] = _vm.theme === 'white', _class[_vm.$style.buttonRed] = _vm.theme === 'red', _class[_vm.$style.buttonGreen] = _vm.theme === 'green', _class[_vm.$style.buttonOrange] = _vm.theme === 'orange', _class[_vm.$style.defaultPadding] = _vm.options.defaultPadding, _class)
  }, _vm.$listeners), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }